import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { authPersistenceMiddleware } from "./feature/auth/authSlice";
export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(authPersistenceMiddleware),
    devTools: process.env.NODE_ENV === "production" ? false : true,
})
